// Copyright 2025-2026 Florian Gallon. All Rights reserved.
import React from 'react';

const ALERT_TONES = {
  info: {
    backgroundColor: 'var(--surface-card)',
    borderColor: 'var(--border-subtle)',
  },
  success: {
    backgroundColor: 'var(--status-success-soft)',
    borderColor: 'var(--status-success)',
  },
  warning: {
    backgroundColor: 'var(--status-warning-soft)',
    borderColor: 'var(--status-warning)',
  },
  danger: {
    backgroundColor: 'var(--status-danger-soft)',
    borderColor: 'var(--status-danger)',
  },
};

export default function Alert({ tone = 'info', title, children, className = '' }) {
  const toneStyle = ALERT_TONES[tone] || ALERT_TONES.info;

  return (
    <div
      role="alert"
      className={`rounded-lg border p-4 text-[var(--text-primary)] ${className}`}
      style={toneStyle}
    >
      {title && <p className="font-semibold text-[var(--text-primary)] mb-1">{title}</p>}
      {children && <div className="text-[var(--text-secondary)] text-sm">{children}</div>}
    </div>
  );
}
